import Vue from 'vue'

const state = {
    search: '',
    tags: [],
    areas: [],
    progress: 'all',
    areas: [],
    groups: [],
    all_tags: [],
    all_areas: [],
    has_event_listner: false,
    video_height: ''
}

const actions = {
    SET_SEARCH(context, [search]) {
        context.commit('SAVE_SEARCH', [search])
    },

    SET_TAGS(context, [tags]) {
        context.commit('SAVE_TAGS', [tags])
    },

    SET_AREAS(context, [areas]) {
        context.commit('SAVE_AREAS', [areas])
    },

    SET_TAGS_AREAS(context, [areas, groups, all_tags, all_areas]) {
        context.commit('SAVE_TAGS_AREAS', [areas, groups, all_tags, all_areas])
    },

    SET_PROGRESS(context, [progress]) {
        context.commit('SAVE_PROGRESS', [progress])
    },

    SET_CLEAR_FILTERS(context, [search, areas, progress]) {
        context.commit('SAVE_CLEAR_FILTERS', [search, areas, progress])
    },

    SET_HAS_EVENT_LISTNER(context, [has_event_listner]) {
        context.commit('SAVE_HAS_EVENT_LISTNER', [has_event_listner])
    },

    SET_VIDEO_HEIGHT(context, [video_height]) {
        context.commit('SAVE_VIDEO_HEIGHT', [video_height + (video_height * 0.03)])
    },
}

const mutations = {
    SAVE_SEARCH: (state, [search]) => {
        Vue.set(state, 'search', search)
    },

    SAVE_TAGS: (state, [tags]) => {
        Vue.set(state, 'tags', tags)
    },

    SAVE_AREAS: (state, [areas]) => {
        Vue.set(state, 'areas', areas)
    },

    SAVE_TAGS_AREAS: (state, [areas, groups, all_tags, all_areas]) => {
        Vue.set(state, 'areas', areas)
        Vue.set(state, 'groups', groups)
        Vue.set(state, 'all_tags', all_tags)
        Vue.set(state, 'all_areas', all_areas)
    },

    SAVE_PROGRESS: (state, [progress]) => {
        Vue.set(state, 'progress', progress)
    },

    SAVE_CLEAR_FILTERS: (state, [search, areas, progress]) => {
        Vue.set(state, 'search', search)
        Vue.set(state, 'areas', areas)
        Vue.set(state, 'progress', progress)
    },

    SAVE_HAS_EVENT_LISTNER: (state, [has_event_listner]) => {
        Vue.set(state, 'has_event_listner', has_event_listner)
    },

    SAVE_VIDEO_HEIGHT: (state, [video_height]) => {
        Vue.set(state, 'video_height', video_height)
    },
}

const getters = {
    search: state => {
        return state.search
    },

    tags: state => {
        return state.tags
    },

    areas: state => {
        return state.areas
    },

    progress: state => {
        return state.progress
    },

    areas: state => {
        return state.areas
    },

    groups: state => {
        return state.groups
    },

    all_tags: state => {
        return state.all_tags
    },

    all_areas: state => {
        return state.all_areas
    },

    has_event_listner: state => {
        return state.has_event_listner
    },

    video_height: state => {
        return state.video_height
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
